import { assign, cloneDeep, isEqual } from 'lodash';
import { Component, DoCheck, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AutoSavePersistService } from './auto-save-persist.service';

@Component({
  selector: 'app-auto-save',
  template: ''
})
export class AutoSaveComponent implements OnInit, DoCheck {
  private cacheModel;

  // Change detection is not working for immutables, so this needs to be an Object
  @Input()
  public model: Object;

  @Input()
  public storageKey;

  @Output()
  public modelChange = new EventEmitter<Object>();

  constructor(private readonly autoSavePersistService: AutoSavePersistService) {
  }

  ngOnInit() {
    this.loadHandler();
  }

  ngDoCheck() {
    if (!isEqual(this.model, this.cacheModel)) {
      this.autoSavePersistService.save(this.storageKey, this.model);
      this.cacheModel = cloneDeep(this.model);
      this.emitModelChange();
    }
  }

  private loadHandler(): void {
    const actualItem = this.autoSavePersistService.load(this.storageKey);

    if (typeof actualItem !== 'undefined') {
      assign(this.model, actualItem);
    }
  }

  private emitModelChange(): void {
    this.modelChange.emit(this.model);
  }
}
